import config from 'config/index';

/**
 * 解析URL参数
 * @example ?id=123456&a=b
 * @return Object {id:123456,a:b}
 */
export function urlParse() {
  let url = window.location.href;
  let obj = {};
  let reg = /[?&][^?&]+=[^?&]+/g;
  let arr = url.match(reg);
  // ['?id=12345', '&a=b']
  if (arr) {
    arr.forEach(item => {
      let tempArr = item.substring(1).split('=');
      let key = decodeURIComponent(tempArr[0]);
      let val = decodeURIComponent(tempArr[1]);
      obj[key] = val;
    });
  }
  return obj;
}

export function formatDate(date, fmt) {
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(
      RegExp.$1,
      (date.getFullYear() + '').substr(4 - RegExp.$1.length)
    );
  }
  let o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds()
  };
  for (let k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      let str = o[k] + '';
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length === 1 ? str : padLeftZero(str)
      );
    }
  }
  return fmt;
}

function padLeftZero(str) {
  return ('00' + str).substr(str.length);
}
/**
 * 在URL中获得参数
 * @param {String} qs 参数名
 * @param {String} url 可选，指定URL
 */
export function getUrlParams(qs, url) {
  if (!url) url = location.href;
  const searchUrl = new URL(url);

  return searchUrl.searchParams.get(qs);
}

/**
 * 深拷贝
 * @param {*} source 拷贝对象
 */
export function deepClone(source) {
  if (!source && typeof source !== 'object') {
    throw new Error('error arguments', 'shallowClone');
  }
  const targetObj = source.constructor === Array ? [] : {};
  for (const keys in source) {
    if (source.hasOwnProperty(keys)) {
      if (source[keys] && typeof source[keys] === 'object') {
        targetObj[keys] = source[keys].constructor === Array ? [] : {};
        targetObj[keys] = deepClone(source[keys]);
      } else {
        targetObj[keys] = source[keys];
      }
    }
  }
  return targetObj;
}

export function setCookie(name, value, days = 7, domain = config.domain) {
  var d = new Date();
  d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days);
  window.document.cookie =
    name +
    '=' +
    value +
    ';path=/;' +
    'domain=' +
    domain +
    ';expires=' +
    d.toGMTString();
}
// 对输入的内容进行防sql注入
export function changeStr(string) {
  let str = string;
  str = str.toString();
  str = str.replace(str.match(/</g), '&lt;');
  str = str.replace(str.match(/>/g), '&gt;');
  // 去掉所有的换行符
  str = str.replace(/\r\n/g, '');
  str = str.replace(/\n/g, '');

  // 去掉所有的空格（中文空格、英文空格都会被替换）
  str = str.replace(/\s/g, ' ');
  return str;
}

export function getCookie(name) {
  var v = window.document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
  return v ? v[2] : null;
}

export function deleteCookie(name) {
  this.setCookie(name, '', -1);
}
// 判断是否为空
export function isNull(str) {
  if (str === '') return true;
  if (str === null) return true;
  var regu = '^[ ]+$';
  var re = new RegExp(regu);
  return re.test(str);
}
export function checkUrl(url) {
  if (url.indexOf('http') < 0) {
    return `${config.imageBaseUrl}${url}`;
  } else {
    return url;
  }
}

export function toArr(obj) {
  let arr = [];
  for (let [key, value] of Object.entries(obj)) {
    let obj1 = {
      label: value,
      value: parseInt(key)
    };
    arr.push(obj1);
  }
  return arr;
}

export function keyToValue(obj = {}) {
  let obj2 = {};
  for (const [key, value] of Object.entries(obj)) {
    obj2[value] = key;
  }
  return obj2;
}
export function deleteKey(target = {}, params = []) {
  params.map(key => {
    delete target[key];
  });
}
let checkType = (function () {
  let rules = {
    email(str) {
      return /^[\w-]+(\.[\w-]+)*@[\w-]+(\.[\w-]+)+$/.test(str);
    },
    tel(str) {
      return /^1[3|4|5|6|7|8|9][0-9]{9}$/.test(str);
    },
    mobile(str) {
      return /^(0\d{2,3}-\d{7,8})(-\d{1,4})?$/.test(str);
    },
    number(str) {
      return /^[0-9]*$/.test(str);
    },
    english(str) {
      return /^[a-zA-Z]+$/.test(str);
    },
    text(str) {
      return /^\w+$/.test(str);
    },
    chinese(str) {
      return /^[\u4E00-\u9FA5]+$/.test(str);
    },
    lower(str) {
      return /^[a-z]+$/.test(str);
    },
    upper(str) {
      return /^[A-Z]+$/.test(str);
    },
    password(str) {
      return /^[\w_-]{6,16}$/.test(str);
    },
    require(str) {
      return /\S/.test(str);
    }
  };
  // 暴露接口
  return {
    /**
     *  校验
     * @param {*} str 校验的对象
     * @param {*} type 校验类型
     */
    check(str, type) {
      return rules[type] ? rules[type](str) : false;
    },
    // 添加规则
    addRule(type, fn) {
      rules[type] = fn;
    }
  };
})();

export { checkType };
/**
//  * 打乱数组排序
 * @param {*} arr;
 */
export function shuffle(arr) {
  let i = arr.length;
  while (i) {
    let j = Math.floor(Math.random() * i--);
    [arr[j], arr[i]] = [arr[i], arr[j]];
  }
  return arr;
}

/* 判断访问终端 */
export function getClientInfo() {
  window.browser = {
    versions: (function () {
      var u = navigator.userAgent;
      // var app = navigator.appVersion;
      return {
        trident: u.indexOf('Trident') > -1 /* IE内核 */,
        presto: u.indexOf('Presto') > -1 /* opera内核 */,
        webKit: u.indexOf('AppleWebKit') > -1 /* 苹果、谷歌内核 */,
        gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') === -1 /* 火狐内核 */,
        mobile: !!u.match(/AppleWebKit.*Mobile.*/) /* 是否为移动终端 */,
        ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) /* ios终端 */,
        android: u.indexOf('Android') > -1 ||
          u.indexOf('Linux') > -1 /* android终端或者uc浏览器 */,
        iPhone: u.indexOf('iPhone') > -1 /* 是否为iPhone或者QQHD浏览器 */,
        iPad: u.indexOf('iPad') > -1 /* 是否iPad */,
        webApp: u.indexOf('Safari') === -1 /* 是否web应该程序，没有头部与底部 */,
        weixin: u.toLowerCase().indexOf('micromessenger') > -1 /* 是否是微信 */
      };
    })(),
    language: (navigator.browserLanguage || navigator.language).toLowerCase()
  };
}
